module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<label class=\"dropdown-label\">")
    ; __append(escapeFn( locals.label ))
    ; __append("</label> <div class=\"dropdown\"> <button class=\"btn ")
    ; __append(escapeFn( locals.btnClasses ))
    ; __append(" dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\"> ")
    ; __append(escapeFn( locals.currentChoice.readable ))
    ; __append(" </button> <input type=\"hidden\" value=\"")
    ; __append(escapeFn( locals.currentChoice.option ))
    ; __append("\" name=\"")
    ; __append(escapeFn( locals.name ))
    ; __append("\"> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.choices).each(function(choice) { 
    ; __append(" <li data-option=\"")
    ; __append(escapeFn( choice.option ))
    ; __append("\" class=\"dropdown-item\">")
    ; __append(escapeFn( choice.readable ))
    ; __append("</li> ")
    ;  }); 
    ; __append(" <li> <div id=\"loader\" class=\"loader\"></div> </li> </ul> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/selector.ejs
// module id = 1196
// module chunks = 1